import Vue from 'vue';
import _ from 'lodash';
import * as types from './types';

const mutations = {
  [types.SET_REPORT_STATEMENTS_FOR_TYPE]: (state, payload) => {
    Vue.set(state.reportingStatements, payload.type, _.cloneDeep(payload.statements));
  },
  [types.SET_CAMPAIGN_REPORT_CONFIGURATION]: (state, payload) => {
    state.campaignReportConfiguration = payload;
  },
  [types.PUBLISH_CAMPAIGN_REPORT_STATEMENTS]: (state, payload) => {
    state.campaignReportConfiguration.published = payload;
  },
  [types.SET_CAMPAIGN_SCREENSHOTS_NAMES]: (state, payload) => {
    state.campaignScreenshotNames = payload;
  },
  [types.ADD_CAMPAIGN_SCREENSHOTS_NAME]: (state, payload) => {
    state.campaignScreenshotNames.unshift(payload);
  },
  [types.REMOVE_CAMPAIGN_SCREENSHOTS_NAME]: (state, payload) => {
    const index = state.campaignScreenshotNames.indexOf(payload);
    if (index > -1) {
      state.campaignScreenshotNames.splice(index, 1);
    }
  },
  [types.UPDATE_SUMMARY_ENABLED_STATEMENTS]: (state, payload) => {
    for (const reportType in state.reportingStatements) {
      if (state.reportingStatements[reportType]) {
        state.reportingStatements[reportType].forEach((statement) => {
          statement.summaryEnabled = !!payload.includes(statement.id);
        });
      }
    }
  },
};

export default mutations;
